module.exports = __webpack_public_path__ + "img/user-a.fe147d50.svg";